/**
 * Тона меток и ширины колонок таблицы планов. Вынесено из
 * `components/PlansTable.tsx` (нарезка 14.10.26).
 */

import type { Mark } from "@/lib/plans";

/** Цвета статусов те же, что в CRM: закупщик узнаёт их не читая. */
export const STATUS_TONE: Record<number, string> = {
  1: "text-warn bg-warn-bg border-warn/25", // Активный
  2: "text-err bg-err-bg border-err/25", // Отмена
  3: "text-ok bg-ok-bg border-ok/25", // Отгружен
};

/** Статусы СТРОКИ плана: ждёт — тоном «Активного», сделано — «Отгружен»,
 *  отменена — «Отмена», пересорт — нейтрально (ни то ни другое). */
export const LINE_STATUS_TONE: Record<number, string> = {
  1: "text-warn bg-warn-bg border-warn/25", // Активно
  2: "text-ok bg-ok-bg border-ok/25", // Создан Заказ
  3: "text-ok bg-ok-bg border-ok/25", // Отгружен
  4: "text-err bg-err-bg border-err/25", // Отменен
  5: "text-fg-muted bg-neutral-bg border-border", // Пересорт
};

export const PRODUCE_TONE: Record<number, string> = {
  1: "text-fg-muted bg-neutral-bg border-border", // Не задано
  2: "text-err bg-err-bg border-err/25", // Нужны изменения
  3: "text-ok bg-ok-bg border-ok/25", // Все ОК
};

/** Тона меток техкарты и оплаты группы — теми же токенами, что статусы. */
export const MARK_TONE: Record<Mark["tone"], string> = {
  ok: "text-ok bg-ok-bg border-ok/25",
  err: "text-err bg-err-bg border-err/25",
  muted: "text-fg-muted bg-neutral-bg border-border",
};

/**
 * Ширины колонок — по ИМЕНИ колонки, а не по её порядковому номеру.
 *
 * Раньше ширина выбиралась через `index === 7`, и вставка колонки в середину
 * молча перекашивала всё правее. Имя переживает перестановку.
 *
 * «Товар» — ширина фото (15.09.26): название и артикул ушли в подсказку, и
 * резиновой колонке растягивать нечего. Остаток строки забирает пустой хвост
 * справа (`TAIL`), поэтому числа от ширины окна не разъезжаются.
 */
export const W: Record<string, string> = {
  plan: "w-[76px]",
  date: "w-[80px]",
  product: "w-[48px]",
  supplier: "w-[110px]",
  lines: "w-[56px] text-right",
  planned: "w-[80px] text-right",
  ordered: "w-[80px] text-right",
  amount: "w-[104px] text-right",
  card: "w-[74px]",
  status: "w-[104px]",
  produce: "w-[120px]",
};

/** Колонка чекбокса выбора — у шапки, заголовка группы и строки одна. */
export const PICK = "flex h-full w-[34px] flex-none items-center justify-center";

/** Пустой хвост строки. */
export const TAIL = "min-w-0 flex-1";
